import { Table, TableBody, TableCell } from "@material-ui/core";
import { calculateQuarterly, calculateYearly, formatMoneyCents } from "../../helpers";
import { BlackCellBorderWhite, BrightYellowCellBorder, LightYellowCellBorder, StyledTableRow } from "../Page/TableStyles";




export default function BreakdownTable(props) {
    const {formData, estimatedDailyUsage, estimatedStorage, estimatedDailyExportAfterStorage} = props;

    return (
        <>
            <Table size='small'>
                <TableBody>
                    <StyledTableRow>
                        <BlackCellBorderWhite colSpan={2}>
                            Your Estimated Energy Breakdown
                        </BlackCellBorderWhite>
                    </StyledTableRow>
                    <StyledTableRow>
                        <BrightYellowCellBorder>Usage Breakdown</BrightYellowCellBorder>
                        <BrightYellowCellBorder>Total</BrightYellowCellBorder>
                        <BrightYellowCellBorder>Current KWH Rate</BrightYellowCellBorder>
                        <BrightYellowCellBorder>Daily Savings</BrightYellowCellBorder>
                        <BrightYellowCellBorder>Quarterly Savings</BrightYellowCellBorder>
                        <BrightYellowCellBorder>Annual Savings</BrightYellowCellBorder>
                    </StyledTableRow>
                    <StyledTableRow>
                        <BlackCellBorderWhite>Usage Savings</BlackCellBorderWhite>
                        <TableCell>{estimatedDailyUsage}</TableCell>
                        <TableCell>{formatMoneyCents(formData.powerPrice)}</TableCell>
                        <TableCell>{formatMoneyCents(estimatedDailyUsage * formData.powerPrice)}</TableCell>
                        <TableCell>{formatMoneyCents(calculateQuarterly(estimatedDailyUsage * formData.powerPrice))}</TableCell>
                        <TableCell>{formatMoneyCents(calculateYearly(estimatedDailyUsage * formData.powerPrice))}</TableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <BrightYellowCellBorder>Storage Savings</BrightYellowCellBorder>
                        <LightYellowCellBorder>{estimatedStorage}</LightYellowCellBorder>
                        <LightYellowCellBorder>{formatMoneyCents(formData.powerPrice)}</LightYellowCellBorder>
                        <LightYellowCellBorder>{formatMoneyCents(estimatedStorage * formData.powerPrice)}</LightYellowCellBorder>
                        <LightYellowCellBorder>{formatMoneyCents(calculateQuarterly(estimatedStorage * formData.powerPrice))}</LightYellowCellBorder>
                        <LightYellowCellBorder>{formatMoneyCents(calculateYearly(estimatedStorage * formData.powerPrice))}</LightYellowCellBorder>
                    </StyledTableRow>
                    <StyledTableRow>
                        <BlackCellBorderWhite>Export Savings (FIT)</BlackCellBorderWhite>
                        <TableCell>{estimatedDailyExportAfterStorage}</TableCell>
                        <TableCell>{formatMoneyCents(formData.feedInTariff)}</TableCell>
                        <TableCell>{formatMoneyCents(formData.feedInTariff * estimatedDailyExportAfterStorage)}</TableCell>
                        <TableCell>{formatMoneyCents(calculateQuarterly(formData.feedInTariff * estimatedDailyExportAfterStorage))}</TableCell>
                        <TableCell>{formatMoneyCents(calculateYearly(formData.feedInTariff * estimatedDailyExportAfterStorage))}</TableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <TableCell>&nbsp;</TableCell>
                        <TableCell>&nbsp;</TableCell>
                        <BlackCellBorderWhite>Total Savings</BlackCellBorderWhite>
                        <TableCell>{formatMoneyCents(((estimatedDailyUsage + estimatedStorage) * formData.powerPrice) + (formData.feedInTariff * estimatedDailyExportAfterStorage))}</TableCell>
                        <BrightYellowCellBorder>{formatMoneyCents(calculateQuarterly((estimatedDailyUsage + estimatedStorage) * formData.powerPrice) + calculateQuarterly(formData.feedInTariff * estimatedDailyExportAfterStorage))}</BrightYellowCellBorder>
                        <BrightYellowCellBorder>{formatMoneyCents(calculateYearly((estimatedDailyUsage + estimatedStorage) * formData.powerPrice) + calculateYearly(formData.feedInTariff * estimatedDailyExportAfterStorage))}</BrightYellowCellBorder>
                    </StyledTableRow>
                    <StyledTableRow>
                        <TableCell>&nbsp;</TableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                        <TableCell colSpan={3} style={{padding: 0, verticalAlign: "top"}}>
                            <div style={{maxWidth: '350px', border: '2px solid black', padding: '10px', textAlign: 'center'}}>
                                <span style={{display: 'flex', alignItems: 'center', height: '100%'}}>Estimated savings, fixed to todays pricing, not including future price increases</span>
                            </div>
                        </TableCell>
                        <TableCell colSpan={3} style={{padding: 0}}>
                            <Table size="small">
                                <TableBody>
                                    <StyledTableRow>
                                        <BrightYellowCellBorder colSpan={3} style={{textAlign: 'center', fontWeight: 'bold'}}>Estimated</BrightYellowCellBorder>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <BlackCellBorderWhite>5 Year</BlackCellBorderWhite>
                                        <BlackCellBorderWhite>10 Year</BlackCellBorderWhite>
                                        <BlackCellBorderWhite>25 Year</BlackCellBorderWhite>
                                    </StyledTableRow>
                                    <StyledTableRow>
                                        <TableCell>{formatMoneyCents((calculateYearly((estimatedDailyUsage + estimatedStorage) * formData.powerPrice) + calculateYearly(formData.feedInTariff * estimatedDailyExportAfterStorage)) * 5)}</TableCell>
                                        <TableCell>{formatMoneyCents((calculateYearly((estimatedDailyUsage + estimatedStorage) * formData.powerPrice) + calculateYearly(formData.feedInTariff * estimatedDailyExportAfterStorage)) * 10)}</TableCell>
                                        <TableCell>{formatMoneyCents((calculateYearly((estimatedDailyUsage + estimatedStorage) * formData.powerPrice) + calculateYearly(formData.feedInTariff * estimatedDailyExportAfterStorage)) * 25)}</TableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableCell>
                    </StyledTableRow>
                </TableBody>
            </Table>
        </>
    )
}